import React from "react";
import { Dialog } from "@mui/material";

import AButton from "views/pages/manage/common/form-fields-mui/AButton";

const PTMConfirmationDialog = ({ isOpen, setOpen, goAhead, type }) => {
  const closeDialog = () => {
    setOpen(false);
  };

  return (
    <Dialog open={isOpen} fullWidth size="md">
      <div className="p-4 confirm-rejection-dialog">
        <div className="d-flex justify-content-between">
          <div style={{ margin: "auto" }}>
            <div
              style={{
                fontWeight: 500,
                fontSize: "16px",
                lineHeight: "24px",
                textAlign: "center",
              }}
            >
              {type === "PTM"
                ? "You should schedule PTM at least 7 days in advance to ensure maximum participation from parents. Are you sure you want to schedule this PTM?"
                : "You should schedule Orientation at least 7 days in advance to ensure maximum participation. Are you sure you want to schedule this Orientation?"}
            </div>
          </div>
          {/* <CrossIcon onClick={closeDialog} /> */}
        </div>
        <div className="d-flex justify-content-center mt-4">
          <AButton variant="primary_filled" onClick={goAhead}>
            Yes
          </AButton>

          <AButton
            className="reject-btn px-5"
            variant="danger_filled"
            onClick={closeDialog}
            // style={{ width: "max-content" }}
          >
            No
          </AButton>
        </div>
      </div>
    </Dialog>
  );
};

export default PTMConfirmationDialog;
